import { create } from 'zustand'
import { message as $message } from 'antd'

import {
    batchSetMinPurchaseAmt,
    queryMinPurchaseAmt,
    queryDefaultMinPurchaseInfo,
    setDefaultMinPurchaseInfo
} from '@/services/myPartner'

interface ISupplierMinPurchaseAmtItem {
    /**
     * @description     起采金额
     */
    minPurchaseAmt: number

    /**
     * @description     起采数量
     */
    minPurchaseCount: number

    /**
     * @description     供应商coid
     */
    supplierCoId: string
    /**
     * @description     分销商coId 这里拿到的其实都是自己
     */
    channelCoId: string
}

interface ISupplierMinPurchaseAmt {
    [key: string]: ISupplierMinPurchaseAmtItem
}

export interface State {
    /**
     * @description     供应商自己的默认起采金额
     */
    defaultMinPurchaseAmt: number
    /**
     * @description     修改供应商自己的默认的起采金额loading
     */
    submitting: boolean
    /**
     * @description     供应商给自己设置的起采金额列表
     */
    supplierMinPurchaseAmts: ISupplierMinPurchaseAmt
}

export interface Action {
    /**
     * @description     获取供应商自己的默认的起采金额
     */
    getDefaultMinPurchaseAmt: () => Promise<number>
    /**
     * @description     修改供应商自己的默认的起采金额
     */
    updateDefaultMinPurchaseAmt: (params: any) => Promise<void>
    /**
     * @description     根据coIds获取供应商给自己设置的起采金额
     */
    getSupplierMinPurchaseAmtByCoIds: (params: any) => Promise<void>
    /**
     * @description     根据coIds修改分销商的起采金额
     */
    updateChannelMinPurchaseAmtByCoIds: (params: any) => Promise<void>
}

const initialState: State = {
    defaultMinPurchaseAmt: 0,
    submitting: false,
    supplierMinPurchaseAmts: {}
}

/**
 * 起采金额
 */
const useMinPurchaseAmount = create<State & Action>((set, get) => ({
    ...initialState,
    getDefaultMinPurchaseAmt: async () => {
        try {
            const { success, data, message } = await queryDefaultMinPurchaseInfo()
            if (success) {
                const { minPurchaseAmt } = data
                set({ defaultMinPurchaseAmt: minPurchaseAmt ?? 0 })

                return minPurchaseAmt ?? 0
            } else {
                $message.error(message)
            }
        } catch (error) {
            console.error(error)
        }
    },
    updateDefaultMinPurchaseAmt: async ({ amt } = {}) => {
        const { submitting } = get()
        if (submitting) {
            return
        }
        set({ submitting: true })
        try {
            const { success, message } = await setDefaultMinPurchaseInfo({
                minPurchaseAmt: amt
            })
            if (success) {
                $message.success('操作成功')
                set({ defaultMinPurchaseAmt: amt ?? 0 })
            } else {
                $message.error(message)
            }
        } catch (error) {
            console.error(error)
        }
        set({ submitting: false })
    },
    getSupplierMinPurchaseAmtByCoIds: async ({ coIds } = {}) => {
        if (!(coIds || []).filter(v => !!v).length) {
            return
        }
        try {
            const { success, data, message } = await queryMinPurchaseAmt({
                supplierCoIds: coIds
            })
            if (success) {
                const temp = get()?.supplierMinPurchaseAmts || {}
                const supplierMinPurchaseAmts = (data || []).reduce((result, item) => {
                    result[item.supplierCoId] = item
                    return result
                }, temp)
                set({ supplierMinPurchaseAmts })
            } else {
                $message.error(message)
            }
        } catch (error) {
            console.error(error)
        }
    },
    updateChannelMinPurchaseAmtByCoIds: async ({ coIds, amt } = {}) => {
        if (!(coIds || []).filter(v => !!v).length) {
            return
        }
        try {
            const { success, message } = await batchSetMinPurchaseAmt({
                channelCoIds: coIds,
                minPurchaseAmt: amt
            })
            if (success) {
                $message.success('操作成功')
            } else {
                $message.error(message)
            }
        } catch (error) {
            console.error(error)
        }
    }
}))

export default useMinPurchaseAmount
